// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wpqL","left":"styles_left__1RpJi"};